import { AppButton } from '../ui/AppButton';
import { AppModal } from '../ui/AppModal';

type HelperDueReminderLimitationModalProps = {
  open: boolean;
  title: string;
  confirmLabel: string;
  cancelLabel: string;
  introText: string;
  limitation1: string;
  limitation2: string;
  limitation3: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const HelperDueReminderLimitationModal = ({
  open,
  title,
  confirmLabel,
  cancelLabel,
  introText,
  limitation1,
  limitation2,
  limitation3,
  onConfirm,
  onCancel,
}: HelperDueReminderLimitationModalProps) => (
  <AppModal
    open={open}
    onClose={onCancel}
    title={title}
    titleId="helper-due-reminder-limitation-heading"
    hideCloseButton
    closeAriaLabel={cancelLabel}
    panelClassName="max-w-sm p-4"
  >
    <p className="text-sm text-gray-700 dark:text-gray-200">{introText}</p>
    <ul className="mt-3 list-disc space-y-2 pl-5 text-sm text-gray-600 dark:text-gray-300">
      <li>{limitation1}</li>
      <li>{limitation2}</li>
      <li>{limitation3}</li>
    </ul>
    <div className="mt-4 flex gap-3">
      <AppButton type="button" variant="secondary" onClick={onCancel} className="flex-1">
        {cancelLabel}
      </AppButton>
      <AppButton type="button" variant="primary" onClick={onConfirm} className="flex-1">
        {confirmLabel}
      </AppButton>
    </div>
  </AppModal>
);
